import './bootstrap';
import * as bootstrap from 'bootstrap5';

const btnBackToTop = document.getElementById('btn-back-to-top');
document.addEventListener('scroll', () => {
    let scrolled = document.scrollingElement.scrollTop;
    let position = btnBackToTop.offsetTop + 100;
    setTimeout(function () {
        if (scrolled > position) {
            btnBackToTop.style.display = 'block';
        } else if (scrolled < 100) {
            btnBackToTop.style.display = 'none';
        }
    }, 500);
});

// scroll body to 0px on click
btnBackToTop.addEventListener('click', function (e) {
    e.preventDefault();
    document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

//-----------------Menu desktop------------------------

// Función para cerrar todos los submenus
function closeAllSubmenus() {
    const submenus = document.querySelectorAll('.submenu__desktop');
    const icons = document.querySelectorAll('.menu__link i');
    submenus.forEach(submenu => {
        submenu.classList.remove('active');
    });

    icons.forEach(icon => {
        icon.classList.remove('active');
    });
}

// Función para manejar el clic en un elemento del menú
function handleMenuClick(event) {
    const menuItem = event.currentTarget;
    const submenuId = menuItem.dataset.submenu;
    const submenu = document.getElementById(submenuId);
    const icon = menuItem.querySelector('.menu__link i');

    if (submenuId) {
        event.preventDefault();
    }

    // Verificar si el submenú está visible o no
    if (submenu.classList.contains('active')) {
        submenu.classList.remove('active');  // Cierra el submenú si ya está abierto
        icon.classList.remove('active') // cambia el icono mirando hacia abajo
    } else {
        closeAllSubmenus();  // Cierra todos los demás submenús
        submenu.classList.add('active');  // Abre el submenu seleccionado
        icon.classList.add('active') // cambia el icono mirando hacia arriba
    }
}

// Manejar el clic en el documento para cerrar submenús si se hace clic fuera
function handleClickOutside(event) {
    const isMenuItem = event.target.closest('.menu__item');
    const isSubmenuLink = event.target.closest('.submenu__desktop a');

    if (isSubmenuLink) {
        return;
    }

    if (!isMenuItem) {
        closeAllSubmenus();
    }
}

// Asignar eventos a los elementos del menú
const menuItems = document.querySelectorAll('.menu__item');
menuItems.forEach(item => {
    item.addEventListener('click', handleMenuClick);
});

// Escuchar clics fuera del menú para cerrar submenús
document.addEventListener('click', handleClickOutside);

// Permitir que los enlaces funcionen normalmente
document.querySelectorAll('.submenu__link').forEach(link => {
    link.addEventListener('click', function (event) {
        event.stopPropagation(); // Prevenir que el evento se propague y cierre el menú
    });
});

// Permitir que los enlaces funcionen normalmente
document.querySelectorAll('.submenus__link').forEach(link => {
    link.addEventListener('click', function (event) {
        event.stopPropagation(); // Prevenir que el evento se propague y cierre el menú
    });
});

//-----------------Fin menu desktop------------------------

//-----------------Menu responsive-------------------------
const btnMenuResponsive = document.querySelector('.btn__menu-responsive');
const btnMenuResponsiveIcon = document.querySelector('.btn__menu-responsive i');
const burgerMenu = document.querySelector('.burger__menu');
btnMenuResponsive.addEventListener('click', function () {
    btnMenuResponsive.classList.toggle('active');
    burgerMenu.classList.toggle('active');

    if (btnMenuResponsive.classList.contains('active')) {
        btnMenuResponsiveIcon.classList.add('fa-times')
        btnMenuResponsiveIcon.classList.remove('fa-bars')
    } else {
        btnMenuResponsiveIcon.classList.remove('fa-times')
        btnMenuResponsiveIcon.classList.add('fa-bars')
    }
});

// Seleccionamos los elementos con el atributo data-anim
const animItems = document.querySelectorAll('[data-anim]')

const animateSingleElements = () => {

    // Definimos una función que se encargará de añadir la clase 'inView' cuando entren a la vista
    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inView')
            }
        })
    }

    // Definimos un objeto con las opciones que le pasaremos al IntersectionObserver
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    }

    // Creamos una instancia de IntersectionObserver con la función handleIntersection como callback
    const observer = new IntersectionObserver(handleIntersection, options)

    // Añadimos los elementos que queremos observar a la instancia de IntersectionObserver
    animItems.forEach(item => {
        observer.observe(item)
    })
}

//-----------------Fin Menu responsive-------------------------

animateSingleElements();
